import { MapPin } from "lucide-react";
import ViewToggle from "./ViewToggle";
import SortingFilter from "./SortingFilter";
import { useSearch } from "@/context/SearchContext";

interface PropertyResultsHeaderProps {
  count: number;
  searchQuery: string | null;
  displayMode: "grid" | "list";
  setDisplayMode: (mode: "grid" | "list") => void;
  onSortChange?: (sortValue: string) => void;
  sortBy?: string;
}

const PropertyResultsHeader = ({
  count,
  searchQuery,
  displayMode,
  setDisplayMode,
  onSortChange,
  sortBy: externalSortBy,
}: PropertyResultsHeaderProps) => {
  // Try to use SearchContext if available, otherwise use props
  let contextSortBy;
  let handleSortChange;

  try {
    const searchContext = useSearch();
    contextSortBy = searchContext.sortBy;
    handleSortChange = searchContext.handleSortChange;
  } catch (error) {
    // If SearchContext is not available, use the props instead
    contextSortBy = externalSortBy;
    handleSortChange = onSortChange;
  }

  // Use context values if available, otherwise fall back to props
  const activeSortBy = contextSortBy || externalSortBy || "created_at";
  const handleSort = handleSortChange || onSortChange || (() => {});

  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-lg py-2 px-3 mb-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 shadow-sm border-l-4 border-propertylk-blue border-t border-r border-b border-gray-100 sticky top-0 z-10">
      <div>
        <span className="font-medium text-propertylk-darkblue">{count}</span>{" "}
        properties found
        {searchQuery && (
          <span className="ml-2">
            for "
            <span className="font-medium text-propertylk-blue">
              {searchQuery}
            </span>
            "
          </span>
        )}
      </div>

      <div className="flex items-center gap-3 w-full sm:w-auto justify-between sm:justify-end">
        <SortingFilter onSortChange={handleSort} defaultValue={activeSortBy} />
        <ViewToggle displayMode={displayMode} setDisplayMode={setDisplayMode} />
      </div>
    </div>
  );
};

export default PropertyResultsHeader;
